import DecorativeImage from "components/decorative-image/DecorativeImage";
import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import { handleEnterSpaceKey } from "utils";

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/questions/CheckboxQuestionOption.scss';

const CheckboxQuestionOption = ({ checkboxName, option, onCheckboxChange, isDisabled }) => {
  const { id, qid, text, selected, img, imgAlt } = option;
  const checkboxQid = qid || "none";
  const checkboxId = `${checkboxName}-${id}-${checkboxQid}`;

  const handleCheckboxChange = () => {
    if (isDisabled) {
      return;
    }
    return onCheckboxChange(option);
  };

  const handleOnKeyUp = (event) => {
    if (isDisabled) {
      return;
    }
    return handleEnterSpaceKey(event, () => onCheckboxChange(option));
  };

  return (
    <li className="csw-q-cbx-o csw-q-option" aria-labelledby={`${checkboxId}-lbl`}>
      <input
        className="csw-q-cbx-input csw-q-option-input sr-only outline-trigger"
        type="checkbox"
        name={checkboxName}
        id={checkboxId}
        value={text}
        checked={selected}
        disabled={isDisabled}
        onChange={handleCheckboxChange}
      />
      <label
        className="csw-q-cbx-lbl csw-q-option-lbl outline"
        id={`${checkboxId}-lbl`}
        htmlFor={checkboxId}
        onKeyUp={handleOnKeyUp}
        role="checkbox"
        aria-checked={selected}
        aria-disabled={isDisabled}
      >
        <span
          className={classNames("csw-q-cbx-chk csw-option-check-border", { "has-image": !!img })}
          aria-hidden="true"
        >
          {" "}
        </span>
        {/* Always include text, but hide visually when image is present */}
        <span className={classNames("csw-q-cbx-txt", { "sr-only": !!img })}>{text}</span>

        {/* Show image when present, aria-hidden b/c text is available to screen reader */}
        {img && <DecorativeImage className="csw-q-cbx-image" src={img} alt={imgAlt || text || ""} />}
      </label>
    </li>
  );
};

CheckboxQuestionOption.propTypes /* remove-proptypes */ = {
  checkboxName: PropTypes.string.isRequired,
  option: PropTypes.object,
  onCheckboxChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};

export default CheckboxQuestionOption;
